import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { SettingsCardsPageSkeleton } from 'src/components/pages/settings/settingsSkeleton';
import { Dialog } from 'src/components/widgets/dialog';
import { backofficeUrl, T } from 'src/shared/helpers';
import { usePageTitle } from 'src/shared/hooks/usePageTitle';

// The page has no real content yet: the skeleton is shown blurred behind the coming-soon
// modal so the module reads as an upcoming placeholder.
const ComingSoonBackground = styled.div`
    filter: blur(3px);
    opacity: 0.55;
    pointer-events: none;
    user-select: none;
`;

const ComingSoonMessage = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: ${(props) => props.theme.app.component.card.text.color};
    line-height: 1.5;

    a {
        color: ${(props) => props.theme.app.secondary};
    }
`;

const ProofingHubInternal: FC = () => {
    const navigate = useNavigate();
    usePageTitle(T._('Proofing Hub', 'Admin'));

    const goToSalesChannelsAndModules = () => navigate(backofficeUrl('/sales-channels-and-modules'));

    return (
        <>
            <ComingSoonBackground aria-hidden='true'>
                <SettingsCardsPageSkeleton />
            </ComingSoonBackground>

            <Dialog
                size='small'
                title={T._('Coming soon', 'Admin')}
                onClose={goToSalesChannelsAndModules}
                buttons={[{ label: T._('Got it', 'Admin'), onClick: goToSalesChannelsAndModules }]}
            >
                <ComingSoonMessage>
                    <span>{T._('In the coming months we will launch a new module to manage proofing processes with your B2B customers.', 'Admin')}</span>
                    <span>
                        {T._('To find out more, write to us at', 'Admin')} <a href='mailto:help@zakeke.com'>help@zakeke.com</a>
                    </span>
                </ComingSoonMessage>
            </Dialog>
        </>
    );
};

export default ProofingHubInternal;
